import {
  Box, Button,
  Chip,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow, Tooltip,
  Typography
} from "@mui/material";
import moment from "moment";
import {grey} from "@mui/material/colors";
import {useEffect, useState} from "react";
import axios from "axios";
import {IconCode, IconRefresh, IconReload, IconRestore} from "@tabler/icons-react";
import {toast} from "react-toastify";
import {ContainerLogsModal} from "./components/container-logs-modal";


export const HealthCheckMonitoring = ({project}) => {
  const [containers, setContainers] = useState([]);
  const [fetchedDate, setFetchedDate] = useState(null);
  const [selectedContainer, setSelectedContainer] = useState(null);

  useEffect(() => {
    if (!project?.configuration?.health_check_api) {
      return;
    }
    fetchContainers().then(() => console.log("Fetched first time"))
    const subscribe = setInterval(() => {
      fetchContainers().then(() => console.log("Fetch containers"))
    }, 1000 * 60)

    return () => clearInterval(subscribe);
  }, [project?.configuration?.health_check_api]);

  const fetchContainers = async () => {
    if (!project?.configuration?.health_check_api) {
      return;
    }

    const url = new URL(project?.configuration?.health_check_api || "");
    url.pathname = `/health`;
    try {
      const response = await axios.get(url.href);
      setFetchedDate(new Date());
      console.log("Fetch containers", response);
      setContainers(response?.data || []);
    } catch (error) {
      console.log(error);
    }
  }

  const restartContainer = async (container) => {
    if (!project?.configuration?.health_check_api || !container?.id) {
      return;
    }

    const url = new URL(project?.configuration?.health_check_api || "");
    url.pathname = `/container/restart/${container?.id}`;
    try {
      await axios.post(url.href);
      toast.success(`Container '${container?.name}' restarted`)
      fetchContainers().then(() => console.log("Restart container re-fetch"))
    } catch (error) {
      console.log(error);
      toast.error(error?.message || `Container '${container?.name}' failed to restart`)
    }
  }

  return (
    <>
      <ContainerLogsModal open={!!selectedContainer} handleClose={() => setSelectedContainer(null)} container={selectedContainer} project={project} />

      <Grid container maxWidth={"xl"} spacing={2} sx={{mx: "auto", p: {xs: 2, md: 4}, overflowY: "auto"}}>
        <Grid item xs={12}>
          <Stack direction={"row"} gap={1} justifyContent={"space-between"}>
            <Box>
              <Typography fontWeight={700} fontSize={"1.05em"} gutterBottom>Health Check Monitoring</Typography>
              <Typography fontWeight={400} color={grey[600]} variant={"body2"} fontSize={"0.85em"}>
                Last Update: {fetchedDate ? moment(fetchedDate).format("dddd, MMMM Do, YYYY HH:mm") : "/"}
              </Typography>
            </Box>
            <Box>
              <Button onClick={fetchContainers} startIcon={<IconReload size={18} />} color={'secondary'} variant={"modal"} sx={{borderRadius: "8px"}}>
                Refresh
              </Button>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: 600}}>Name</TableCell>
                <TableCell sx={{fontWeight: 600}}>Status</TableCell>
                <TableCell sx={{fontWeight: 600}}>State</TableCell>
                <TableCell sx={{fontWeight: 600}}>Health</TableCell>
                <TableCell sx={{fontWeight: 600}}></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {containers?.map(container => {
                let color = "error";
                if (container?.active) {
                  color = {
                    "healthy": "success",
                    "unhealthy": "error",
                    "unknown": "default"
                  }[container?.health]
                }

                return (
                  <TableRow key={container?.id} hover>
                    <TableCell sx={{fontWeight: 500}}>{container?.name}</TableCell>
                    <TableCell sx={{fontWeight: 400}}>{container?.status}</TableCell>
                    <TableCell sx={{fontWeight: 400}}>{container?.state}</TableCell>
                    <TableCell padding={"checkbox"} sx={{fontWeight: 400}}>
                      <Chip color={color} label={container?.health} sx={{width: "100%"}}/>
                    </TableCell>
                    <TableCell padding={"checkbox"} sx={{fontWeight: 400, px: 2}}>
                      <Stack direction={"row"} gap={1}>
                        <Tooltip title={"Restart Container"}>
                          <IconButton size={"small"} onClick={() => restartContainer(container)}>
                            <IconRefresh size={21}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={"Logs"}>
                          <IconButton size={"small"} onClick={() => setSelectedContainer(container)}>
                            <IconCode size={21}/>
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  )
}